import { render } from "./DetailGroup.vue?vue&type=template&id=df053d34&scoped=true"
import script from "./DetailGroup.vue?vue&type=script&lang=js"
export * from "./DetailGroup.vue?vue&type=script&lang=js"

import "./DetailGroup.vue?vue&type=style&index=0&id=df053d34&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df053d34"]])

export default __exports__